<div class="category-card mb-3">
  <button class="category-header" (click)="expanded = !expanded">
    <span class="d-flex align-items-center gap-2">
      <span class="category-title">{{index + 1}} - {{categoryData.category.name}}</span>
      @if(categoryData.category.tooltip){<button class="btn btn-xs btn-ghost ms-1" triggers="hover" [ngbTooltip]="categoryData.category.tooltip"><i class="fas fa-circle-question"></i></button>}
    </span>
    <span class="d-flex align-items-center gap-2">
      <span class="progress-text">{{progress()}}%</span>
      <i class="fas" [class.fa-chevron-down]="!expanded" [class.fa-chevron-up]="expanded"></i>
    </span>
  </button>
  @if(expanded){
  <div class="category-body">
    <div class="table-responsive">
      <table class="table table-sm table-bordered align-middle mb-0">
        <thead>
          <tr>
            <th style="width:60px">Item</th>
            <th>Criterio</th>
            <th style="width:190px">Respuesta</th>
            <th style="width:110px" class="text-center">Evidencia</th>
            <th style="width:170px" class="text-center">Progreso</th>
          </tr>
        </thead>
        <tbody>
          @for(ans of categoryData.answers; track ans.question.id; let i = $index){
          <app-evaluation-question-row [answer]="ans" [locked]="locked" [reviewMode]="reviewMode" [signed]="signed" [indexLabel]="(index+1) + '.' + (i+1)" [missingIds]="missingIds" [completedIds]="completedIds" (changed)="changed.emit()"></app-evaluation-question-row>
          } @empty {
          <tr><td colspan="5" class="text-center text-muted py-3 small">Sin preguntas en esta categoría</td></tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  }
</div>
